import { render, staticRenderFns } from "./c_doctorTeam.vue?vue&type=template&id=38dacb67&scoped=true&"
import script from "./c_doctorTeam.vue?vue&type=script&lang=js&"
export * from "./c_doctorTeam.vue?vue&type=script&lang=js&"
import style0 from "./c_doctorTeam.vue?vue&type=style&index=0&id=38dacb67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dacb67",
  null
  
)

export default component.exports